<template>
    <form @submit.prevent="createLine()">
        <div class="form-row">
            <div class="form-group col-md-3">
                <label>Date de facturation <span class="text-danger">*</span></label>
                <input type="date" class="form-control" v-model="form.date_operation" required />
            </div>
            <div class="form-group col-md-3">
                <label>Type</label>
                <select class="form-control" v-model="form.type">
                    <option value="Normale">Definitive</option>
                    <option value="Pro forma">Pro forma</option>
                </select>
            </div>
            <div class="form-group col-md-6">
                <label>Client</label><span class="text-danger">*</span>
                <SelectClient :key="key" @set-selected="setClient" :line="form.client" :readOnly="readOnly" required />
            </div>
        </div>

        <div class="row">
            <!-- <div class="form-group col-3">
                <label>Le document est expirable ?</label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <div class="input-group-text">
                            <input type="checkbox" v-model="form.expirable">
                        </div>
                    </div>

                    <input v-if="form.expirable == true" type="date" class="form-control form-control-sm" v-model="form.date_expiration" required />
                </div>
            </div> -->
            <div class="form-group col-3">
                <label>Appliquer la TVA (%)</label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <div class="input-group-text">
                            <input type="checkbox" v-model="avec_tva" @change="applyTaxes()">
                        </div>
                    </div>
                    <input v-if="avec_tva == true" type="number" min="0" step="0.01"
                        class="form-control form-control-sm" v-model="tva" required />
                </div>
            </div>
            <div class="form-group col-3">
                <label>Appliquer la TPS (%)</label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <div class="input-group-text">
                            <input type="checkbox" v-model="avec_tps" @change="applyTaxes()">
                        </div>
                    </div>
                    <input v-if="avec_tps == true" type="number" min="0" step="0.01"
                        class="form-control form-control-sm" v-model="tps" required />
                </div>
            </div>
            <div class="form-group col-3">
                <label>Appliquer la CSS (%)</label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <div class="input-group-text">
                            <input type="checkbox" v-model="avec_css" @change="applyTaxes()">
                        </div>
                    </div>
                    <input v-if="avec_css == true" type="number" min="0" step="0.01"
                        class="form-control form-control-sm" v-model="css" required />
                </div>
            </div>
        </div>

        <table class="table text-sm">
            <thead>
                <tr>
                    <th scope="col"></th>
                    <th scope="col">Description</th>
                    <th scope="col">Prix unitaire</th>
                    <th scope="col">Qté</th>
                    <th scope="col">Total</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(selection, index) in lignes_selectionnes" :key="index">
                    <td style="width: 5%;">
                        <button class="btn btn-sm btn-danger" @click.prevent="removeCourse(index)">
                            <i class="fa-solid fa-trash-alt "></i>
                        </button>
                    </td>
                    <td v-if="selection.isTitle" colspan="4">
                        <input type="text" class="form-control form-control-sm" v-model="selection.description"
                            required>
                    </td>
                    <template v-else>
                        <td style="width: 45%;">
                            <input type="text" class="form-control form-control-sm" v-model="selection.description"
                                required>
                        </td>
                        <td style="width: 20%;">
                            <input type="number" class="form-control form-control-sm" v-model="selection.prix_unitaire"
                                required @change="onLineChange(selection)">
                        </td>
                        <td style="width: 10%;">
                            <input type="number" min="1" class="form-control form-control-sm" v-model="selection.qte"
                                required @change="onLineChange(selection)">
                        </td>
                        <td style="width: 20%;">
                            <input type="number" class="form-control form-control-sm" :value="selection.net_a_payer"
                                disabled>
                        </td>
                    </template>
                </tr>
            </tbody>
        </table>

        <div class="d-flex">
            <a href="#" class="btn text-primary" @click.prevent="addCourse()">+ Ajouter une ligne</a>
            <a href="#" class="btn text-info" @click.prevent="addCourse(true)">+ Ajouter un titre</a>
        </div>

        <div class="form-group col-4">
            <label>Voulez-vous appliquer une remise ?</label>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <div class="input-group-text">
                        <input type="checkbox" v-model="form.avec_reduction">
                    </div>
                </div>
                <input v-if="form.avec_reduction == true" type="number" min="0" step="any"
                    class="form-control form-control-sm" v-model="form.reduction" required />
            </div>
        </div>

        <ul>
            <li>
                <strong>Total HT: </strong> {{ $moneyFormat(montantTotalHT) }}
            </li>
            <li v-if="avec_tva">
                <strong>TVA ({{ tva }} %) : </strong> {{ $moneyFormat(getTva()) }}
            </li>
            <li v-if="avec_tps">
                <strong>TPS (- {{ tps }} %) : </strong>{{ $moneyFormat(getTps()) }}
            </li>
            <li v-if="avec_css">
                <strong>CSS ({{ css }} %) : </strong>{{ $moneyFormat(getCss()) }}
            </li>
            <li v-if="avec_reduction">
                <strong>Reduction : </strong> {{ $moneyFormat(reduction) }}
            </li>
            <li>
                <strong>Total TTC: </strong> {{ $moneyFormat(montantTTC) }}
            </li>
        </ul>

        <div class="form-group">
            <label>Conditions:</label>
            <textarea class="form-control" v-model="form.conditions" rows="2"></textarea>
        </div>

        <div class="form-group">
            <label>Mentions:</label>
            <textarea class="form-control" v-model="form.mentions" rows="2"></textarea>
        </div>

        <div v-if="!readOnly" class="d-flex justify-content-between ">
            <button v-if="line" type="button" class="btn btn-secondary" @click="this.$emit('reset_mode')"
                :disabled="isLoading">
                <i class="fa-solid fa-chevron-left"></i> Annuler
            </button>
            <button type="submit" class="btn btn-primary" :disabled="isLoading">
                <i class="fa-solid fa-save"></i> {{ buttonLabel }}
                <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </div>
    </form>
</template>
<script>
import $ from "jquery";
import moment from 'moment'
import { defineComponent } from 'vue';
import SelectClient from '@/views/operations/clients/SelectClient.vue';

export default defineComponent({
    name: 'FormFacture',
    inject: ['dialogRef'],
    components: { SelectClient },
    props: {
        line: {
            type: Object,
            default: null,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            key: 1,
            isLoading: false,
            table: 'factures',
            baseUrl: this.$store.getters.apiCourses,
            lignes_selectionnes: [
                {
                    id: 1,
                    description: '',
                    qte: 1,
                    prix_unitaire: 0,
                    net_a_payer: 0
                }
            ],
            tva: 18,
            tps: 9.5,
            css: 1,
            avec_tva: false,
            avec_tps: false,
            avec_css: false,
            form: {
                expirable: false,
                date_operation: moment().format('YYYY-MM-DD'),
                date_expiration: '',
                avec_reduction: false,
                reduction: 0,
                total_tva: 0,
                total_css: 0,
                total_tps: 0,
                total_ht: 0,
                total_ttc: 0,
                lignes_selectionnes: [],
                type: 'Pro forma',
                utilisateur: this.$store.getters.user.name
            },
            lastId: 1
        }
    },
    created() {
        if (this.dialogRef.data) {
            this.form = {
                date_operation: this.dialogRef.data.date_operation,
                date_expiration: this.dialogRef.data.date_expiration,
                tva: this.dialogRef.data.tva,
                tps: this.dialogRef.data.tps,
                css: this.dialogRef.data.css,
                conditions: this.dialogRef.data.conditions,
                mentions: this.dialogRef.data.mentions,
                reduction: this.dialogRef.data.reduction,
                total_ht: this.dialogRef.data.total_ht,
                total_ttc: this.dialogRef.data.total_ttc,
                content: this.dialogRef.data.content,
                type: this.dialogRef.data.type,
                client: this.dialogRef.data.client,
                avec_reduction: parseFloat(this.dialogRef.data.reduction) > 0  // Ajout de cette ligne
            }

            if (this.dialogRef.data.tva && parseFloat(this.dialogRef.data.tva)) {
                this.avec_tva = true
                this.tva = this.dialogRef.data.tva
            }

            if (this.dialogRef.data.css && parseFloat(this.dialogRef.data.css)) {
                this.avec_css = true
                this.css = this.dialogRef.data.css
            }

            if (this.dialogRef.data.tps && parseFloat(this.dialogRef.data.tps)) {
                this.avec_tps = true
                this.tps = this.dialogRef.data.tps
            }

            if (this.dialogRef.data.content) {
                this.lignes_selectionnes = []
                for (let index = 0; index < this.dialogRef.data.content.length; index++) {
                    const element = this.dialogRef.data.content[index];
                    this.lignes_selectionnes.push({
                        id: this.lastId++,
                        description: element.description,
                        qte: element.qte,
                        reduction: element.reduction,
                        isTitle: element.isTitle,
                        prix_unitaire: element.prix_unitaire,
                        net_a_payer: element.net_a_payer
                    })
                    this.lastId++
                }
            }
        }
    },
    computed: {
        buttonLabel() {
            return this.dialogRef.data ? "Mettre à jour" : "Enregistrer";
        },
        montantTotalHT() {
            let total = 0
            for (let index = 0; index < this.lignes_selectionnes.length; index++) {
                const element = this.lignes_selectionnes[index];
                if (parseFloat(element.net_a_payer)) {
                    total = total + parseFloat(element.net_a_payer)
                }
            }
            return total
        },
        montantTTC() {
            let total = this.montantTotalHT
            if (this.avec_tps == true && parseFloat(this.tps)) {
                total = total - ((this.montantTotalHT * parseFloat(this.tps)) / 100)
            }
            if (this.avec_css == true && parseFloat(this.css)) {
                total = total + ((this.montantTotalHT * parseFloat(this.css)) / 100)
            }
            if (this.form.avec_reduction == true && parseFloat(this.form.reduction)) {
                total = total - parseFloat(this.form.reduction)
            }
            if (this.avec_tva == true && parseFloat(this.tva)) {
                total = total + ((this.montantTotalHT * parseFloat(this.tva)) / 100)
            }
            return total
        }
    },
    methods: {
        applyTaxes() {
            if (this.avec_tva == true) this.form.tva = this.tva
            else this.form.tva = null
            if (this.avec_tps == true) this.form.tps = this.tps
            else this.form.tps = null
            if (this.avec_css == true) this.form.css = this.css
            else this.form.css = null
        },
        addCourse(title = false) {
            this.lastId++
            if (title) {
                this.lignes_selectionnes.push({
                    id: this.lastId,
                    isTitle: true,
                    description: ''
                })
            }
            else this.lignes_selectionnes.push({
                id: this.lastId,
                description: '',
                qte: 1,
                reduction: 0,
                prix_unitaire: 0,
                net_a_payer: 0,
                isTitle: false,
            })
        },
        removeCourse(key) {
            this.lignes_selectionnes = this.lignes_selectionnes.filter((data, index) => {
                return index != key
            })
        },
        setClient(client) {
            this.form.client = client
        },
        createLine() {
            this.isLoading = true
            this.form.content = this.lignes_selectionnes
            this.form.total_ht = this.montantTotalHT
            this.form.total_ttc = this.montantTTC

            let url = this.baseUrl + '/api/factures'
            if (this.dialogRef.data && this.dialogRef.data.id) {
                url = this.baseUrl + '/api/factures/' + this.dialogRef.data.id + '/update'
            }

            this.axios.post(url, this.form)
                .then(response => {
                    this.isLoading = false
                    if (response.data.success === true) {
                        this.resetForm()
                        $('#refresh' + this.table).click()
                        this.$toast.add({
                            severity: 'success',
                            detail: response.data.message,
                            life: 3000
                        });
                        this.dialogRef.close()
                    }
                    else {
                        response.data.errors.forEach(element => {
                            this.$toast.add({
                                severity: 'warn',
                                summary: 'Oups !',
                                detail: element,
                                life: 7000
                            });
                        });
                    }
                }).catch(() => {
                    this.isLoading = false
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Probleme de connexion',
                        detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                        life: 5000
                    });
                })
        },
        onLineChange(selection) {
            let line = this.lignes_selectionnes.filter(item => item.id == selection.id)[0]
            if (parseInt(line.prix_unitaire) && parseInt(line.qte)) {
                line.net_a_payer = parseInt(line.prix_unitaire) * parseInt(line.qte)
            }
        },
        getTva() {
            let total = this.montantTotalHT
            if (total && parseFloat(this.tva)) {
                return (total * parseFloat(this.tva)) / 100
            }
        },
        getTps() {
            let total = this.montantTotalHT
            if (total && parseFloat(this.tps)) {
                return (total * parseFloat(this.tps)) / 100
            }
        },
        getCss() {
            let total = this.montantTotalHT
            if (total && parseFloat(this.css)) {
                return (total * parseFloat(this.css)) / 100
            }
        },
        resetForm() {
            this.lignes_selectionnes = [
                {
                    id: 1,
                    description: '',
                    qte: 1,
                    prix_unitaire: 0,
                    net_a_payer: 0
                }
            ],
                this.form = {
                    client_id: '',
                    expirable: false,
                    date_operation: moment().format('YYYY-MM-DD'),
                    date_expiration: '',
                    tva: 18,
                    tps: 9.5,
                    css: 1,
                    avec_reduction: false,
                    reduction: 0,
                    total_ht: 0,
                    total_ttc: 0,
                    lignes_selectionnes: [],
                    type: ''
                },
                this.lastId = 1
        }
    }
})
</script>